'use client'

import React, { useEffect, useState } from 'react';
import styles from './FeatureIcon.module.css';

interface FeatureIconProps {
    icon: React.ReactNode;
    color?: string;
    label: string;
}

interface IconProps {
    size?: string | number;
    color?: string;
  }


export default function FeatureIcon({ icon, color, label }: FeatureIconProps) {
    const [mounted, setMounted] = useState(false);
    const [computedColor, setComputedColor] = useState<string>(color || '');

    useEffect(() => {
        setMounted(true);

        if (!color) {
            const computedStyle = getComputedStyle(document.documentElement);
            setComputedColor(computedStyle.getPropertyValue('--icon-color').trim());
        }
    }, [color]);

    if (!mounted) return null;

    return (
        <div className={styles.container}>
            <div className={styles.icon}>
            {React.cloneElement(icon as React.ReactElement<IconProps>, {
                size: '100%',
                color: color || computedColor,
            })}

            </div>
            <span>{label}</span>
        </div>
    );
}